import { ParseResult, Schema } from "@effect/schema";
import { ChainKey } from "../chain";
import { Address } from "../address";
import { Effect, pipe, String, Array } from "effect";

export type MarketChainUid = typeof MarketChainUid.Type;
export type MarketChainUidEncoded = typeof MarketChainUid.Encoded;

export const MarketChainUid = Schema.Struct({
  chainKey: ChainKey,
  marketAddress: Address,
}).annotations({ identifier: "MarketChainUid" });

export type MarketChainUidFromString = typeof MarketChainUidFromString.Type;
export type MarketChainUidFromStringEncoded =
  typeof MarketChainUidFromString.Encoded;

export const MarketChainUidFromString = Schema.transformOrFail(
  Schema.String,
  MarketChainUid,
  {
    decode: (s, _, ast) =>
      pipe(
        Effect.gen(function* () {
          const tuple = pipe(s, String.split("-"));

          const chainKey = yield* pipe(
            tuple,
            Array.get(0),
            Effect.andThen(Schema.validate(ChainKey))
          );

          const marketAddress = yield* pipe(
            tuple,
            Array.get(1),
            Effect.andThen(Schema.validate(Address))
          );

          return { chainKey, marketAddress };
        }),
        Effect.mapBoth({
          onFailure: (error) => new ParseResult.Type(ast, s, error.message),
          onSuccess: (marketChainUid) => marketChainUid,
        })
      ),
    encode: ({ chainKey, marketAddress }) => {
      const encoded = `${chainKey}-${marketAddress}`;

      return Effect.succeed(encoded);
    },
  }
);
